import { Reducer } from 'redux';
import { IResultsState, ResultsActions, ResultsActionEnum } from '.';

export const initialResultsState: IResultsState = {
  showResultsPanel: false,
  auctionResultsName: '',
  auctionProductResults: [],
  isLoading: false,
  identification: '',
  errorMessage: ''
};

export const resultsReducer: Reducer<IResultsState, ResultsActions> = (
  state = initialResultsState,
  action: ResultsActions
) => {
  switch (action.type) {
    case ResultsActionEnum.ShowResultsPanel:
      return {
        ...state,
        showResultsPanel: action.state?.showResultsPanel,
        auctionResultsName: action.state?.auctionResultsName,
        identification: action.state?.identification
      };
    case ResultsActionEnum.HideResultsPanel:
      return {
        ...state,
        showResultsPanel: false,
        auctionResultsName: '',
        auctionProductResults: [],
      };
    case ResultsActionEnum.FetchAuctionResults:
      return {
        ...state,
        isLoading: true,
        identification: action.state?.identification,
      };
    case ResultsActionEnum.FetchAuctionResultsSuccess:
      return {
        ...state,
        isLoading: false,
        auctionProductResults: action.state?.auctionProductResults,
      };
    case ResultsActionEnum.FetchAuctionResultsFailed:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.state?.errorMessage || 'unknown error'
      };
    default:
      return state;
  }
};
